import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateAssetComponent } from './components/assets/create-asset/create-asset.component';
import { EditAssetComponent } from './components/assets/edit-asset/edit-asset.component';
import { ImportAssetsComponent } from './components/assets/import-assets/import-assets.component';
import { RegistrationDetailsComponent } from './components/registrations/registration-details/registration-details.component';
import { ImportRegistrationsComponent } from './components/registrations/import-registrations/import-registrations.component';
import { ServiceRecommendationDetailsComponent } from './components/service-recommendations/service-recommendation-details/service-recommendation-details.component';
import { SearchPageComponent } from './components/search-page/search-page.component';
import { CustomerDetailsComponent } from './components/customers/customer-details/customer-details.component';
import { TraceableComponentDetailsComponent } from './components/traceable-components/traceable-component-details/traceable-component-details.component';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { CiamLoginComponent } from './components/auth/ciam-login/ciam-login.component';
import { UnathorizedPageComponent } from './components/auth/unathorized-page/unathorized-page.component';
import { LogoutPageComponent } from './components/auth/logout-page/logout-page.component';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';
import { SparePartDetailsComponent } from './components/spare-parts/spare-part-details/spare-part-details.component';
import { ImportSparePartsComponent } from './components/spare-parts/import-spare-parts/import-spare-parts.component';
import { SiteTreeComponent } from './components/sites/site-tree/site-tree.component';
import { AssetPageComponent } from './components/assets/asset-page/asset-page.component';
import { AssetTechnicalDetailsEditComponent } from './components/assets/asset-technical-details-edit/asset-technical-details-edit.component';

const routes: Routes = [
  { path: 'login', component: CiamLoginComponent },
  { path: 'callback', component: CiamLoginComponent },
  { path: 'unauthorized', component: UnathorizedPageComponent },
  { path: 'logout', component: LogoutPageComponent },

  { path: '', component: SearchPageComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'search', component: SearchPageComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'site-tree/:id', component: SiteTreeComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'asset/:id', component: AssetPageComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'create-asset', component: CreateAssetComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'edit-asset/:id', component: EditAssetComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'edit-technical-details/:id', component: AssetTechnicalDetailsEditComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'registration/:id', component: RegistrationDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'customer/:id', component: CustomerDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'service-recommendation/:id', component: ServiceRecommendationDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'traceable-component/:source/:id', component: TraceableComponentDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'spare-part/:id', component: SparePartDetailsComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'import-assets', component: ImportAssetsComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'import-registrations', component: ImportRegistrationsComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'import-spare-parts', component: ImportSparePartsComponent, canActivate: [AutoLoginPartialRoutesGuard] },

  { path: '**', component: NotFoundPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
